import { render, staticRenderFns } from "./SelectDemo.vue?vue&type=template&id=16c51f16&scoped=true"
import script from "./SelectDemo.vue?vue&type=script&lang=js"
export * from "./SelectDemo.vue?vue&type=script&lang=js"
import style0 from "./SelectDemo.vue?vue&type=style&index=0&id=16c51f16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c51f16",
  null
  
)

export default component.exports